var _a, _b, _c, _d, _e, _f, _g, _h;
import { generateActions } from "../generators/generator.actions";
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./application.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["UpdateApplicationStep"] = "UPDATE_APPLICATION_STEP";
    EActionCustom["DuplicateApplication"] = "DUPLICATE_APPLICATION";
    EActionCustom["getCountSteps"] = "COUNT_APPLICATION_STEPS";
    EActionCustom["RemindCandidateTenant"] = "REMIND_CANDIDATE_TENANT";
    EActionCustom["ApplicationGroupActions"] = "APPLICATION_GROUP_ACTIONS";
    EActionCustom["SetApplicationFlag"] = "SET_APPLICATION_FLAG";
    EActionCustom["SetApplicationNoShow"] = "SET_APPLICATION_NO_SHOW";
    EActionCustom["SetApplicationRating"] = "SET_APPLICATION_RATING";
})(EActionCustom || (EActionCustom = {}));
var generateApplicationGroupActionsActions = function () { return ({
    applicationGroupActionsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ApplicationGroupActions,
        state: EActionState.Start,
    }),
    applicationGroupActionsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ApplicationGroupActions,
        state: EActionState.Success,
    }),
    applicationGroupActionsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ApplicationGroupActions,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateApplicationStepActions = function () { return ({
    updateApplicationStepStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateApplicationStep,
        state: EActionState.Start,
    }),
    updateApplicationStepSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateApplicationStep,
        state: EActionState.Success,
    }),
}); };
var generateSetApplicationFlagActions = function () { return ({
    // A reason flags the candidate for the office, null removes the flag.
    setApplicationFlagStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetApplicationFlag,
        state: EActionState.Start,
    }),
    setApplicationFlagSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetApplicationFlag,
        state: EActionState.Success,
    }),
}); };
var generateSetApplicationNoShowActions = function () { return ({
    setApplicationNoShowStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetApplicationNoShow,
        state: EActionState.Start,
    }),
    setApplicationNoShowSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetApplicationNoShow,
        state: EActionState.Success,
    }),
}); };
var generateSetApplicationRatingActions = function () { return ({
    setApplicationRatingStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetApplicationRating,
        state: EActionState.Start,
    }),
    setApplicationRatingSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetApplicationRating,
        state: EActionState.Success,
    }),
}); };
export var duplicateApplicationStart = createCustomAction({
    entity: GENERATOR_PARAMS.entity,
    custom: EActionCustom.DuplicateApplication,
    state: EActionState.Start,
});
var generateRemindCandidateTenantActions = function () { return ({
    remindCandidateTenantStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemindCandidateTenant,
        state: EActionState.Start,
    }),
    remindCandidateTenantSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemindCandidateTenant,
        state: EActionState.Success,
    }),
    remindCandidateTenantFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemindCandidateTenant,
        state: EActionState.Fail,
    }),
}); };
var generateGetCountStepsActions = function () { return ({
    getCountStepsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.getCountSteps,
        state: EActionState.Start,
    }),
    getCountStepsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.getCountSteps,
        state: EActionState.Success,
    }),
    getCountStepsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.getCountSteps,
        state: EActionState.Fail,
    }),
}); };
export var getDetailStart = (_a = generateActions(GENERATOR_PARAMS), _a.getDetailStart), getDetailSucceeded = _a.getDetailSucceeded, getDetailFailed = _a.getDetailFailed, getPagedStart = _a.getPagedStart, getPagedFailed = _a.getPagedFailed, getPagedSucceeded = _a.getPagedSucceeded, getCountStart = _a.getCountStart, getCountFailed = _a.getCountFailed, getCountSucceeded = _a.getCountSucceeded, 
// getInfiniteLoadStart,
// getInfiniteLoadFailed,
// getInfiniteLoadSucceeded,
createStart = _a.createStart, createSucceeded = _a.createSucceeded, createFailed = _a.createFailed, updateStart = _a.updateStart, updateSucceeded = _a.updateSucceeded, updateFailed = _a.updateFailed, removeStart = _a.removeStart, removeSucceeded = _a.removeSucceeded, removeFailed = _a.removeFailed, archiveStart = _a.archiveStart, archiveSucceeded = _a.archiveSucceeded, archiveFailed = _a.archiveFailed, unarchiveStart = _a.unarchiveStart, unarchiveSucceeded = _a.unarchiveSucceeded, unarchiveFailed = _a.unarchiveFailed;
export var updateApplicationStepStart = (_b = generateUpdateApplicationStepActions(), _b.updateApplicationStepStart), updateApplicationStepSucceeded = _b.updateApplicationStepSucceeded;
export var setApplicationFlagStart = (_c = generateSetApplicationFlagActions(), _c.setApplicationFlagStart), setApplicationFlagSucceeded = _c.setApplicationFlagSucceeded;
export var setApplicationNoShowStart = (_d = generateSetApplicationNoShowActions(), _d.setApplicationNoShowStart), setApplicationNoShowSucceeded = _d.setApplicationNoShowSucceeded;
export var setApplicationRatingStart = (_e = generateSetApplicationRatingActions(), _e.setApplicationRatingStart), setApplicationRatingSucceeded = _e.setApplicationRatingSucceeded;
export var getCountStepsStart = (_f = generateGetCountStepsActions(), _f.getCountStepsStart), getCountStepsSucceeded = _f.getCountStepsSucceeded, getCountStepsFailed = _f.getCountStepsFailed;
export var remindCandidateTenantStart = (_g = generateRemindCandidateTenantActions(), _g.remindCandidateTenantStart), remindCandidateTenantSucceeded = _g.remindCandidateTenantSucceeded, remindCandidateTenantFailed = _g.remindCandidateTenantFailed;
export var applicationGroupActionsStart = (_h = generateApplicationGroupActionsActions(), _h.applicationGroupActionsStart), applicationGroupActionsSucceeded = _h.applicationGroupActionsSucceeded, applicationGroupActionsFailed = _h.applicationGroupActionsFailed;
